import { Stack, Typography } from '@mui/material';
import React from 'react';

import { BookingPartial, ExtraOption } from '../../redux/ellipsisApi';
import { useAppSelector } from '../../redux/hooks';
import { formatCurrency } from '../../theme/theme';
import { getRate } from '../../utils/rateGetter';

interface OwnProps {
  booking: BookingPartial | null | undefined;
  bookableCurrencyCode: string | undefined;
  allExtras: ExtraOption[];
}

const AdditionalItems: React.FC<OwnProps> = (props) => {
  const { booking, allExtras, bookableCurrencyCode } = props;
  const conversionRate = getRate(bookableCurrencyCode ?? 'eur');
  const currencyCode = useAppSelector((state) => state.currency.currencyCode);

  function getOptionalExtras(extraOptions: ExtraOption[]) {
    return (
      <>
        {extraOptions.map((extraOption: any, key: number) => {
          const extraOptionPrice = Math.ceil(
            extraOption.price * conversionRate
          );
          return (
            <Stack direction="row" spacing={2} key={key}>
              {extraOption.qty > 1 && (
                <Typography>{extraOption.qty} x </Typography>
              )}
              {extraOption.price === 0 ? (
                <>
                  <Typography>{extraOption.description}: Free</Typography>
                </>
              ) : (
                <>
                  {extraOption.chargeBasis === 'period' && (
                    <>
                      <Typography>
                        {extraOption.description}: @{' '}
                        {formatCurrency(extraOptionPrice, currencyCode)} /
                        day:{' '}
                      </Typography>
                      <Typography fontWeight="bold">
                        {formatCurrency(
                          extraOptionPrice *
                            (extraOption.qty ?? 1) *
                            (booking?.fullDays ?? 0),
                          currencyCode
                        )}
                      </Typography>
                    </>
                  )}
                  {extraOption.chargeBasis === 'booking' && (
                    <>
                      <Typography>
                        {extraOption.description}: @{' '}
                        {formatCurrency(extraOptionPrice, currencyCode)}
                        /booking:{' '}
                      </Typography>
                      <Typography fontWeight="bold">
                        {formatCurrency(
                          extraOptionPrice * (extraOption.qty ?? 1),
                          currencyCode
                        )}
                      </Typography>
                    </>
                  )}
                </>
              )}
            </Stack>
          );
        })}
      </>
    );
  }

  return getOptionalExtras(allExtras);
};

export default AdditionalItems;
